import React from "react"
import { connect } from "react-redux"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { validateForm } from "../../../../services/validation"
import "./styles.scss"
import {
  fetchDisabilities,
  saveUserData
} from "../../../../services/authentication"

import Form, {
  Group,
  Input,
  Checkbox,
  Select
} from "../../../../components/Form"
import Header from "../../../../components/Header"
import Button from "../../../../components/Button"

class GeneralInformation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        NDISNumber: {
          label: "NDIS Number",
          name: "NDISNumber",
          placeholder: "Enter your NDIS Number here",
          type: "text",
          value: "",
          required: false,
          class: "",
          message: ""
        },
        dontHaveNumber: {
          label: "I don’t have a number or I will add my number later",
          name: "dontHaveNumber",
          type: "checkbox",
          checked: false,
          value: "",
          required: false,
          class: ""
        },
        primaryDisability: {
          label: "Primary Disability",
          name: "primaryDisability",
          placeholder: "Search for my disability",
          value: "",
          options: [],
          required: true,
          class: "",
          message: ""
        },
        secondaryDisability: {
          label: "Secondary Disability",
          name: "secondaryDisability",
          placeholder: "Search for my disability",
          value: "",
          options: [],
          required: false,
          class: "",
          message: ""
        }
      },
      isSubmitted: false,
      disabilitiesLoading: false,
      dataLoading: false
    }
  }

  componentDidMount() {
    const {
      store: { user }
    } = this.props
    const { form } = this.state

    this.setState({ disabilitiesLoading: true })

    fetchDisabilities()
      .then(data => {
        const options = []

        if (data.length) {
          data.map(item => {
            options.push({
              label: item.name,
              value: String(item.id)
            })

            return null
          })

          this.setState({
            form: {
              ...form,
              NDISNumber: {
                ...form.NDISNumber,
                value: user.ndis_number
              },
              primaryDisability: {
                ...form.primaryDisability,
                value: user.primary_disability,
                options
              },
              secondaryDisability: {
                ...form.secondaryDisability,
                value: user.secondary_disability,
                options
              }
            },
            disabilitiesLoading: false
          })
        }
      })
      .catch(() => {})
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const {
      store: { user },
      history,
      onSaveUserData
    } = this.props
    const { form } = this.state

    const invalidFields = validateForm(form)

    this.setState({ dataLoading: true })

    if (
      Object.entries(invalidFields).length === 0 &&
      invalidFields.constructor === Object
    ) {
      const data = {
        ndis_number: form.NDISNumber.value ? form.NDISNumber.value : null,
        primary_disability: form.primaryDisability.value,
        secondary_disability: form.secondaryDisability.value
          ? form.secondaryDisability.value
          : null
      }

      onSaveUserData(data, user.token).then(
        () => {
          history.push("/")
        },
        error => {
          const newState = {
            form: {
              ...this.state.form
            },
            dataLoading: false,
            isSubmitted: true
          }

          if (error && error.ndis_number) {
            newState.form.NDISNumber.message = error.ndis_number[0]
          }

          if (error && error.primary_disability) {
            newState.form.primaryDisability.message =
              error.primary_disability[0]
          }

          this.setState(newState)
        }
      )
    } else {
      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...invalidFields
        },
        dataLoading: false
      })
    }
  }

  render() {
    const { form, isSubmitted, disabilitiesLoading, dataLoading } = this.state
    const {
      store: { user, isLogged }
    } = this.props

    return user.loading || disabilitiesLoading ? (
      <Loader
        type="TailSpin"
        color="#0c4632"
        height={80}
        width={80}
        className="loader loader--flex"
      />
    ) : (
      <div className="general-information">
        <Header
          theme="light"
          user={user}
          isLogged={isLogged}
          hideNotifications
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 authentication_content authentication_content--light">
              <Form onSubmit={this.onSubmit} className="form--light">
                <h2 className="authentication_content_title">
                  Welcome {user.name}, let’s get started with some general
                  information
                </h2>

                <Group>
                  <Input
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={form.NDISNumber}
                  />
                </Group>

                <Group>
                  <Checkbox
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={form.dontHaveNumber}
                  />
                </Group>

                <Group>
                  <Select
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={form.primaryDisability}
                  />
                </Group>

                <Group>
                  <Select
                    onChange={this.onChange}
                    isSubmitted={isSubmitted}
                    field={form.secondaryDisability}
                  />
                </Group>

                <Group className="form_group--padding-top-lg">
                  <Button
                    button={{ type: "submit", disabled: dataLoading }}
                    className="btn--secondary-light btn--width-md btn--height-sm"
                  >
                    Done
                  </Button>
                </Group>
              </Form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

GeneralInformation.propTypes = {
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string,
      name: propTypes.string,
      ndis_number: propTypes.string,
      secondary_disability: propTypes.string,
      primary_disability: propTypes.string,
      loading: propTypes.bool
    }),
    listOfDisabilities: propTypes.arrayOf(propTypes.shape({})),
    isLogged: propTypes.bool
  }).isRequired,
  onSaveUserData: propTypes.func.isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    isLogged: AuthenticationReducer.isLogged
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveUserData: (data, token) => dispatch(saveUserData(data, token))
})

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)
